import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewContainerRef,
  ViewChild,
} from "@angular/core";
import { Subscription } from "rxjs";
import { trigger, transition, animate, style } from "@angular/animations";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { SharedService } from "../../services/shared.service";
import { Popup } from "../../models/popup";
import { CommonModule } from "@angular/common";

@Component({
  selector: "custom-popup",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  inputs: ["ok"],
  animations: [
    trigger("opacity", [
      transition(":enter", [
        style({ opacity: "0" }),
        animate("100ms ease-in", style({ opacity: "1" })),
      ]),
      transition(":leave", [
        style({ opacity: "1" }),
        animate("200ms ease-in", style({ opacity: "0" })),
      ]),
    ]),
  ],
  templateUrl: "./popup.component.html",
})
export class PopupComponent implements OnInit, OnDestroy {
  ok: any;
  popup: Popup = {};
  popupSub: Subscription;
  title: string = "";
  subTitles: string[] = [];
  message: string = "";
  okBtnText: string = "";
  cancelBtnText: string = ";";
  showPopup: boolean = false;

  constructor(
    private sharedService: SharedService,
    private el: ElementRef,
    private translate: TranslateService,
    public viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit() {
    this.popupSub = this.sharedService.popup.subscribe((data) => {
      this.subTitles = [];

      this.popup = data;

      this.sharedService.emitGeneralLoaderEvent(false);

      this.showPopup = Object.keys(this.popup).length !== 0;

      if (this.showPopup) {
        // hangle focus for bettur ux
        requestAnimationFrame(() => {
          const firstFormField =
            this.el.nativeElement.querySelector("input, select");
          const approveBtn =
            this.el.nativeElement.querySelector(".popup-btn-approve");

          if (firstFormField) {
            firstFormField.focus();
          } else {
            approveBtn && approveBtn.focus();
          }
        });

        // support for a single string message
        if (typeof this.popup.message === "string") {
          this.message = this.popup.message;
        } else {
          this.message = "";

          // support for non-string message
          if (this.popup.message && this.popup.message.forEach !== undefined) {
            // array of messages
            this.popup.message.forEach((item) => {
              if (typeof item === "string") {
                // string message in iteration
                this.message += " " + item;
              } else {
                // non-string (e.g. object) message in iteration
                this.message += " " + JSON.stringify(item);
              }
            });
          } else {
            // non-string (e.g. object) single message
            this.message = JSON.stringify(this.popup.message);
          }
        }
      }

      this.popup.title && (this.title = this.popup.title);

      this.subTitles = [];

      if (this.popup.subTitle) {
        if (typeof this.popup.subTitle === "string") {
          this.subTitles.push(this.popup.subTitle);
        } else {
          this.popup.subTitle.forEach((item) => {
            if (item) this.subTitles.push(item);
          });
        }
      } else {
        this.subTitles = [];
      }

      this.cancelBtnText = this.popup.cancelLabel || "translate.alert.cancel";
      this.okBtnText = this.popup.approveLabel || "translate.alert.approve";

      if (typeof this.popup.onload === "function") {
        requestAnimationFrame(() => {
          this.popup.onload(this.el.nativeElement, this.popup);
        });
      }

      if (this.popup.fade) {
        setTimeout(() => {
          this.onCancel();
        }, this.popup.fade);
      }
    });
  }

  ngOnDestroy() {
    this.popupSub?.unsubscribe();
  }

  onOk() {
    if (typeof this.popup.approve === "function") {
      this.popup.approve(this.el.nativeElement, this.popup);
    }
    if (typeof this.popup.onClose === "function") {
      this.popup.onClose(this.el.nativeElement, this.popup);
    }
    if (!this.popup.keep) this.sharedService.emitPopupchReceivedEvent({});
  }
  onCancel() {
    if (typeof this.popup.onClose === "function") {
      this.popup.onClose(this.el.nativeElement, this.popup);
    }
    this.sharedService.emitPopupchReceivedEvent({});
  }

  onCancelByEscEey(e) {
    // close on escape key press
    if (e.keyCode === 27) this.onCancel();
    // approve on enter key press
    if (e.keyCode === 13) this.onOk();
  }
}
